module.exports = __webpack_public_path__ + "static/media/home.ca52eea8.svg";